function install(Vue) {
  Vue.mixin({
    methods: {
      $tIf({ key, fallBack }) {
        const translationExists = this.$te(key);
        if (translationExists) {
          return this.$t(key);
        } else {
          if (
            process.env.NODE_ENV !== "production" ||
            process.env.NODE_ENV !== "sandbox"
          ) {
            this.$logMissingTranslation(key);
          }
          return fallBack || key;
        }
      },
      async $logMissingTranslation(key) {
        // eslint-disable-line no-console
        console.warn(`Translation key: "${key}" was not found.`);
      }
    }
  });
}

export default { install };
